export default __webpack_public_path__ + "static/111-min-min-7795b3dfd1db72a966c4fb1597084a81.jpg";